import script from "./VideoCallPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCallPublic.vue?vue&type=script&setup=true&lang=js"

import "./VideoCallPublic.vue?vue&type=style&index=0&id=28903180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28903180"]])

export default __exports__